import React from 'react';
import QuoteTips from 'pu-react/components/QuoteTips';

import QuoteTipList from '../../data/QuoteTips';

export default () => <QuoteTips list={QuoteTipList} />;
